import * as React from 'react';
import Svg, {G, Path, Rect} from 'react-native-svg';
import {memo} from 'react';

interface IProps {
  width?: number;
  height?: number;
}

const RefiveMenuItemBoilerPlate = memo(
  ({width = 110, height = 110}: IProps) => (
    <Svg width={width} height={height} viewBox="0 0 110 110" fill="none">
      <Rect
        opacity="0.15"
        x="0.5"
        y="0.5"
        width="109"
        height="109"
        rx="7.5"
        fill="#4588FD"
        fill-opacity="0.15"
        stroke="#CFCFCF"
      />
      <G clip-path="url(#clip0_18220_22432)">
        <Path
          d="M55.5973 92C34.8659 92 18 75.1777 18 54.5C18 33.8223 34.8659 17 55.5973 17C64.948 17 73.9124 20.4463 80.8378 26.7057C87.7124 32.9204 92.0269 41.3898 92.991 50.555C93.0958 51.5584 92.3652 52.4573 91.3622 52.5618C90.3592 52.6693 89.4549 51.9377 89.3502 50.9372C87.5387 33.673 73.0291 20.6553 55.6003 20.6553C36.884 20.6523 21.6618 35.8351 21.6618 54.5C21.6618 73.1649 36.887 88.3477 55.5973 88.3477C64.3881 88.3477 72.7237 85.0089 79.0713 78.9435C79.8019 78.2447 80.9606 78.2716 81.6582 79.0003C82.3589 79.729 82.3319 80.8847 81.6013 81.5805C74.5711 88.2999 65.3342 91.997 55.5943 91.997L55.5973 92Z"
          fill="#022649"
        />
        <Path
          d="M55.4985 80.8074C70.0652 80.8074 81.8738 69.0294 81.8738 54.5004C81.8738 39.9714 70.0652 28.1934 55.4985 28.1934C40.9318 28.1934 29.1232 39.9714 29.1232 54.5004C29.1232 69.0294 40.9318 80.8074 55.4985 80.8074Z"
          fill="#A4DB57"
        />
        <Path
          d="M65.8313 30.7553C66.3732 30.3969 66.6397 30.5432 66.6397 30.5432C66.8553 30.6597 66.9092 31.0031 66.9032 31.3406L54.8967 82.0972C54.75 82.7094 54.1093 82.7751 53.8069 82.4346C53.6362 82.2435 53.6452 81.9747 53.6512 81.8732C53.6512 81.8523 53.6571 81.7806 53.6631 81.6641C53.6811 81.3745 53.7021 81.0878 53.723 80.7981C54.3668 72.2809 54.2081 68.972 54.2081 68.972C53.9895 64.3939 53.7829 60.0368 51.2259 58.8093C48.9144 57.6984 45.3454 59.4723 42.9891 60.643C41.6327 61.3149 40.5728 62.0884 39.8422 62.5125C37.5817 63.8145 35.2971 65.0748 33.0485 66.3948C32.9407 66.4575 32.6713 66.6128 32.4048 66.5262C32.2192 66.4664 32.0515 66.2932 32.0036 66.0692C31.9527 65.8423 32.0365 65.6034 32.2162 65.4481C44.6418 52.4633 64.8492 31.4063 65.8313 30.7553Z"
          fill="#3070ED"
        />
        <Path
          d="M54.2649 83.8714C53.7439 83.8714 53.2409 83.6534 52.8846 83.2562C52.6451 82.9904 52.3726 82.5215 52.4175 81.7958L52.4295 81.5868C52.4475 81.2911 52.4684 80.9985 52.4894 80.7028C53.1181 72.3977 52.9744 69.0589 52.9744 69.0261C52.7828 64.9945 52.5852 60.8255 50.6929 59.9176C48.9264 59.0695 45.558 60.7448 43.5429 61.7453C42.6926 62.1664 41.9411 62.6472 41.3392 63.0354C41.0129 63.2444 40.7284 63.4266 40.462 63.5789C39.5008 64.1344 38.5337 64.6809 37.5636 65.2274C36.2821 65.9531 34.9587 66.6997 33.6743 67.4552C32.9676 67.8703 32.3838 67.8136 32.0185 67.6941C31.4017 67.4941 30.9346 66.9714 30.7909 66.3294C30.6472 65.6783 30.8628 65.0094 31.3508 64.5584C63.909 30.5406 64.8072 29.9463 65.1456 29.7223C66.2205 29.0115 67.0109 29.3371 67.2265 29.4535C67.6517 29.6835 68.1547 30.1971 68.1397 31.3529V31.4873L68.1068 31.6187L56.1003 82.3752C55.9296 83.1009 55.4146 83.6355 54.729 83.8116C54.5763 83.8505 54.4206 83.8684 54.2649 83.8684V83.8714ZM49.5342 57.2269C50.3156 57.2269 51.0732 57.3643 51.7648 57.6987C54.9835 59.2457 55.208 63.9403 55.4446 68.9156C55.4506 69.0141 55.5254 70.7612 55.3338 74.8734L65.2324 33.0282C62.5886 35.6622 55.25 43.1849 36.0067 63.2803C36.1205 63.2176 36.2312 63.1519 36.345 63.0891C37.3061 62.5456 38.2673 62.0021 39.2254 61.4496C39.441 61.3242 39.7014 61.157 40.0038 60.9658C40.6566 60.5477 41.471 60.0251 42.4411 59.5443C44.3903 58.5767 47.0969 57.2329 49.5342 57.2329V57.2269Z"
          fill="#022649"
        />
        <Path
          d="M84.2092 86.6391H85.6045V91.9996H86.383V86.6391H87.7722V85.8984H84.2092V86.6391Z"
          fill="#022649"
        />
        <Path
          d="M92.0629 85.8984L90.7125 89.2999L89.3562 85.8984H88.428V91.9996H89.2124V87.4991L90.4131 90.4586H90.988L92.1976 87.4961V91.9996H92.9731V85.8984H92.0629Z"
          fill="#022649"
        />
      </G>
    </Svg>
  ),
);
export default RefiveMenuItemBoilerPlate;
